import { useState, useCallback } from 'react';
import { formatCurrencyNumber } from '../../../../utils/numbers';
import { insertTCIcon, getPerksCardIcon } from '../../../../utils/tbbRegistration';
import CircleQuestionMarkSvg from '../../../../global/SvgComponents/CircleQuestionMark_svg';
import CloseSvg from '../../../../global/SvgComponents/Close_svg';
import { Button, BUTTON_SIZE, BUTTON_TYPE } from '../../../../global/Button';
import Dialog from '../../../../global/Mui/Dialog';

import './PerksCard.scss';

const PerksCard = ({
  payOnShipFee,
  items = [],
  title,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const onClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <div className="PerksCard">
      <div className="PerksCard__title">
        <span className="PerksCard__title-text">
          {title}
        </span>
        {
        payOnShipFee && (
          <div className="PerksCard__title-price">
            <span className="PerksCard__title-value">
              {formatCurrencyNumber(payOnShipFee)}
            </span>
          </div>
        )
      }
      </div>
      <div className="PerksCard__content">
        {(items || []).map(({
          key,
          title: itemTitle,
          description,
        }) => (
          <div className="PerksCard__content-item" key={key}>
            <div className="PerksCard__content-item-icons">
              {getPerksCardIcon(key)}
            </div>
            <div className="PerksCard__content-item-text">
              <span className="PerksCard__content-item-text-title">
                {itemTitle ? insertTCIcon(itemTitle) : ''}
              </span>
              { description && (
              <Button
                type={BUTTON_TYPE.LINK}
                size={BUTTON_SIZE.SMALL}
                onClick={() => { setIsOpen(true); }}
                className="PerksCard__content-item-text-description"
              >
                <CircleQuestionMarkSvg width={24} height={24} />
                {description}
              </Button>
              )}
            </div>
          </div>
        ))}
      </div>
      <Dialog open={isOpen} onClose={onClose} closable>
        <div className="PerksCard__dialog">
          <div className="PerksCard__dialog--accept">
            <div className="PerksCard__dialog--accept--title">
              <span className="PerksCard__dialog--accept--title-text">
                We accept
              </span>
              <Button
                type={BUTTON_TYPE.LINK}
                size={BUTTON_SIZE.SMALL}
                onClick={onClose}
                className="PerksCard__dialog--accept--title-close"
              >
                <CloseSvg />
              </Button>
            </div>
            <div className="PerksCard__dialog--accept--content">
              <ul className="PerksCard__dialog--accept--content-list">
                <li className="PerksCard__dialog--accept--content-list-item">Clothing and apparel</li>
                <li className="PerksCard__dialog--accept--content-list-item">Shoes (including boots, high heels, sneakers)</li>
                <li className="PerksCard__dialog--accept--content-list-item">Socks and clean underwear</li>
                <li className="PerksCard__dialog--accept--content-list-item">Handbags, purses, and backpacks</li>
                <li className="PerksCard__dialog--accept--content-list-item">Outerwear (jackets, vests, puffers)</li>
                <li className="PerksCard__dialog--accept--content-list-item">Swimwear</li>
                <li className="PerksCard__dialog--accept--content-list-item">Uniforms</li>
                <li className="PerksCard__dialog--accept--content-list-item">Ski clothing (snow pants, jackets, vests, puffers)</li>
                <li className="PerksCard__dialog--accept--content-list-item">Costumes (Halloween, etc.)</li>
                <li className="PerksCard__dialog--accept--content-list-item">Hats, caps, mittens, gloves, and scarves</li>
                <li className="PerksCard__dialog--accept--content-list-item">Jewelry and accessories</li>
                <li className="PerksCard__dialog--accept--content-list-item">Stuffed animals</li>
                <li className="PerksCard__dialog--accept--content-list-item">Home textiles (blankets, sheets, pillowcases, towels)</li>
              </ul>
            </div>
          </div>

          <div className="PerksCard__dialog--reject">
            <div className="PerksCard__dialog--reject--title">
              <span className="PerksCard__dialog--reject--title-text">
                We do not accept
              </span>
            </div>
            <div className="PerksCard__dialog--reject--content">
              <ul className="PerksCard__dialog--reject--content-list">
                <li className="PerksCard__dialog--reject--content-list-item">Clothing with paint stains, mold, or motor oil stains</li>
                <li className="PerksCard__dialog--reject--content-list-item">Soiled table linens, dish towels, or cloth napkins</li>
                <li className="PerksCard__dialog--reject--content-list-item">Placemats, oven mitts, or aprons</li>
                <li className="PerksCard__dialog--reject--content-list-item">Pillows, heated blankets, or mattress pads</li>
                <li className="PerksCard__dialog--reject--content-list-item">Half-garments or fabric scraps</li>
                <li className="PerksCard__dialog--reject--content-list-item">Face masks</li>
                <li className="PerksCard__dialog--reject--content-list-item">Pet leashes, beds, or other pet items</li>
                <li className="PerksCard__dialog--reject--content-list-item">Anything soiled with bio materials (pet, human, or otherwise)</li>
              </ul>
            </div>
          </div>
        </div>

      </Dialog>
    </div>
  );
};

export default PerksCard;
